import { LinkTargetTypeEnum } from '../../../common/core-api';
import { type PageCmsPanel } from './panel-types';

// Text and Image panels share the exact same buttonConfig selection shape.
export type PanelButtonConfig = NonNullable<
  Extract<PageCmsPanel['config'], { __typename: 'TextPanelConfig' }>['buttonConfig']
>;

export const CATEGORY_DISPLAY_PREFIX = 'category_';
export const PAGE_DISPLAY_PREFIX = 'page_';

export const EMPTY_BUTTON_CONFIG: PanelButtonConfig = {
  display: 'none',
  category: '',
  text: null,
  url: null,
  externalUrl: '',
  targetType: LinkTargetTypeEnum.NONE
};

export const displayToTargetType = (display: string): LinkTargetTypeEnum => {
  if (!display || display === 'none') {
    return LinkTargetTypeEnum.NONE;
  }
  if (display === 'challenges') {
    return LinkTargetTypeEnum.CHALLENGES_DIRECTORY;
  }
  if (display === 'submitIdea') {
    return LinkTargetTypeEnum.SUBMIT_IDEA;
  }
  if (display === 'custom') {
    return LinkTargetTypeEnum.CUSTOM_EXTERNAL;
  }
  if (display.startsWith(CATEGORY_DISPLAY_PREFIX)) {
    return LinkTargetTypeEnum.CHALLENGE;
  }
  if (display.startsWith(PAGE_DISPLAY_PREFIX)) {
    return LinkTargetTypeEnum.PAGE;
  }
  return LinkTargetTypeEnum.NONE;
};

export const targetTypeToDisplay = (targetType: LinkTargetTypeEnum): string => {
  switch (targetType) {
    case LinkTargetTypeEnum.SUBMIT_IDEA:
      return 'submitIdea';
    case LinkTargetTypeEnum.CHALLENGES_DIRECTORY:
      return 'challenges';
    case LinkTargetTypeEnum.CUSTOM_EXTERNAL:
      return 'custom';
    case LinkTargetTypeEnum.CHALLENGE:
      return CATEGORY_DISPLAY_PREFIX;
    case LinkTargetTypeEnum.PAGE:
      return PAGE_DISPLAY_PREFIX;
    default:
      return 'none';
  }
};

export const getChallengeUrl = (challengeId: string): string => `/category/${challengeId}`;

const PAGE_TYPE_URLS: Record<string, (pageId: string) => string> = {
  community_page: (pageId) => `/hubbub/communitypage/${pageId}`,
  survey: (pageId) => `/survey/submit/${pageId}`,
  url: (pageId) => `/page/redirect/${pageId}`,
  blog: () => '/blog/view',
  people: () => '/user/search'
};

export const getPageUrl = (page: { id: string; type: string }): string => PAGE_TYPE_URLS[page.type]?.(page.id) ?? '';

export const buildButtonConfig = (
  config: PanelButtonConfig,
  changes: { targetType: LinkTargetTypeEnum } & Partial<PanelButtonConfig>
): PanelButtonConfig => ({
  ...config,
  category: '',
  text: '',
  url: '',
  externalUrl: '',
  ...changes,
  display: changes.display ?? targetTypeToDisplay(changes.targetType),
  targetType: changes.targetType
});
